class RegionalOfficesBlock {
    constructor() {
        const select = document.getElementById('regional-offices-select');
        select.addEventListener('click', (e) => this.handleSelectOnChange(e.target.getAttribute('data-item-index')));
        
        const headOfficeIndex = regionOffices.findIndex(x => x.isHeadOffice);
        this.handleSelectOnChange(headOfficeIndex >= 0 ? headOfficeIndex : 0);
    }

    handleSelectOnChange(index) {
        const data = regionOffices[index];
        const regionHeading = document.querySelector('.regional-offices__region-heading')
        const regionAddress = document.querySelector('.regional-offices__region-address')
        const regionPhone = document.querySelector('.regional-offices__region-phone')
        const regionLink = document.querySelector('.regional-offices__region-link')
        const image = document.querySelector('.regional-offices__region-image');

        regionHeading.innerText = data.name;
        regionAddress.innerText = data.address;
        regionPhone.innerText = data.phone;
        regionLink.href = data.linkUrl;
        image.src = data.imageUrl;
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const regionalOfficesBlocks = [...document.querySelectorAll('.regional-offices')]

    if (regionalOfficesBlocks.length && regionOffices.length) {
        new RegionalOfficesBlock();
    }
});

const handleClick = (e) => {
    const target = e.currentTarget;
    const isExpanded = target.classList.contains('regional-offices__button--active')
    target.classList.toggle('regional-offices__button--active');
    if (isExpanded) {
        target.setAttribute('aria-expanded', false)
    } else {
        target.setAttribute('aria-expanded', true)
    }

    closeOtherDropdowns(target);
}

const closeOtherDropdowns = (target) => {
    const dropdownContainers = [...document.querySelectorAll('.regional-offices__container .regional-offices__list--active')].map(x => x.parentElement);
    dropdownContainers.forEach(container => {
        if (container.isSameNode(target.parentElement)) return;
        const button = container.querySelector('.regional-offices__button');
        button.classList.remove('regional-offices__button--active');
    });
}

const init = () => {
    const dropdownButtons = [...document.querySelectorAll('.regional-offices__button')];
    dropdownButtons.forEach(button => {
        button.addEventListener('click', handleClick);
    });
}

const closeDropdowns = (e) => {
    if (e.target.classList.contains('regional-offices__button')) return;
    //class starts with regional-offices and ends with --active
    const dropdowns = [...document.querySelectorAll('[class^=regional-offices][class$=--active]')];
    dropdowns.forEach(dropdown => {
        const classToToggle = dropdown.classList.contains('regional-offices__list') ? 'regional-offices__list--active' : 'regional-offices__button--active';
        dropdown.classList.remove(classToToggle);
    });
}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('click', closeDropdowns);
